export default "__VITE_ASSET__BZGKgU0P__"